import { formatLevel } from "@/lib/plantReal";

const LEVEL_COLORS = { 1: "#E0162B", 2: "#F59E0B", 3: "#3B82F6", 4: "#10B981" };

// Real de Nivel de Servicio como promedio simple de varias plantas: solo lectura, porque el promedio
// puede ser fraccionario y no corresponde a ningún nivel que se pueda capturar.
export default function PlantAverageReal({ label = "Real", icon, value, plantCount, hint, testid }) {
  const text = formatLevel(value);
  const color = text === "" ? undefined : LEVEL_COLORS[Math.min(4, Math.max(1, Math.round(Number(value))))];
  return (
    <div className="flex flex-col gap-1" data-testid={testid}>
      <div className="text-[10px] uppercase tracking-wider text-[var(--ink-soft)] font-bold flex items-center gap-1">
        {icon} {label}
      </div>
      <div
        className="input-field text-sm font-bold cursor-not-allowed bg-[var(--cream-soft)]"
        style={color ? { color, borderColor: color } : {}}
        aria-readonly="true"
        data-testid={`${testid}-value`}
      >
        {text === "" ? "Sin capturar" : `Promedio ${text}`}
      </div>
      <div className="text-[10px] text-[var(--ink-soft)] leading-tight border-l-2 pl-2" data-testid={`${testid}-hint`}>
        Promedio simple de {plantCount} planta{plantCount === 1 ? "" : "s"}.{hint ? ` ${hint}` : ""}
      </div>
    </div>
  );
}
